import React, { useContext, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faAddressCard, faLanguage, faE, faBus, faPen, faEye, faSync, faTimes, faBuildingCircleCheck, faCalendarWeek} from '@fortawesome/free-solid-svg-icons';
import CountUp from 'react-countup';
import { Card, Row, Col, OverlayTrigger, Tooltip, Button, Form } from "react-bootstrap";
import { CSSTransition } from 'react-transition-group';
import ChartsContext from "contexts/ChartsContext";
import TodayRegistration from "./DetailsTable/TodayRegistration";
import CheckinTable from "./DetailsTable/CheckinTable";
import Papa from 'papaparse';
import { useHistory } from 'react-router-dom';


function DataSnapshots({ onRefresh }) {
  const [showCheckinTable, setShowCheckinTable] = useState(false);
  const [showTotalToday, setShowTotalToday] = useState(false);

  const history = useHistory();

  const handleFullListDetailsClick = () => {
    history.push('/admin/eventregadmin');
  };
  const {
    updateTime,
    totalEntries,
    totalToday,
    checkIns,
    relativesCount,
    totalHeadCount,
    checkInGroupSizeTotal,
    timeslots
  } = useContext(ChartsContext);

  // Function to handle PDF download (to be implemented)
  const handleCSVDownload = (data, filename) => {
    // Define the column order
    const columnOrder = [
      'id', 
      'firstname', 
      'lastname', 
      'chinesename', 
      'email', 
      'phone', 
      'checkedIn', 
      'lastNotificationSent', 
      'checkedInTime', 
      'registrationTime'
    ];
    

    // Use PapaParse to unparse the data with the specified columns
    const csv = Papa.unparse({
      fields: columnOrder,
      data: data.map(row => columnOrder.reduce((obj, key) => ({ ...obj, [key]: row[key] }), {}))
    }, {
      quotes: false, // Quote all fields
      quoteChar: '"',
      escapeChar: '"',
      delimiter: ",",
      header: true,
      newline: "\r\n",
      skipEmptyLines: false, // Skip empty lines
      columns: columnOrder // Ensure the columns are in the correct order
    });

    // Create a Blob from the CSV String with UTF-8 BOM to ensure proper display of Chinese characters
    const BOM = "\uFEFF";
    const csvBlob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' });

    // Create a link and trigger the download
    const csvUrl = URL.createObjectURL(csvBlob);
    const downloadLink = document.createElement('a');
    downloadLink.href = csvUrl;
    downloadLink.setAttribute('download', `${filename}.csv`);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };


  // Function to handle closing (to be implemented)
  const handleTableClose = (table) => {
    if (table === 'checkin') {
      setShowCheckinTable(false);
    }
    else if (table === 'totalToday') {
      setShowTotalToday(false);
    }
  };

  const handleDetailsButtonClick = (table) => {
    setShowCheckinTable(table === 'checkin');
    setShowTotalToday(table === 'totalToday');
  };

  return (
    <>
      <Row>
        {/* Total Registrations Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      {/* <FontAwesomeIcon icon={faUsers} className="text-info" /> */}
                      <span className="text-info">總報名</span>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">素食展<span className="text-warning">總</span>報名人數</p>
                      {/* totalEntries counts bookings; the headcount is what the
                          kitchen and the door need, so show people and keep the
                          number of bookings as the smaller figure. */}
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={totalHeadCount} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                      <small className="d-block text-muted">共 {totalEntries} 筆報名</small>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={handleFullListDetailsClick}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>


        {/* Check-in Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      {/* <FontAwesomeIcon icon={faBuildingCircleCheck} className="text-body" /> */}
                      <span className="text-body">已到場</span>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">素食展已<span className="text-warning">已到場</span>總人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={checkInGroupSizeTotal} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('checkin')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>
      </Row>




      {/* Entry is staggered this year, so the overall total is not enough on its
          own -- this shows which window is filling up. */}
      {timeslots && timeslots.length > 0 && (
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4" className="font-weight-bold mb-0">
                  各<span className="text-warning">入場時段</span>報名人數
                </Card.Title>
                <p className="card-category">含同行人數，額滿後將無法選擇該時段</p>
              </Card.Header>
              <Card.Body>
                <Row>
                  {timeslots.map((slot) => {
                    const used = slot.capacity ? Math.min((slot.taken / slot.capacity) * 100, 100) : 0;
                    const tone = slot.full ? 'danger' : used >= 80 ? 'warning' : 'success';
                    return (
                      <Col md="4" key={slot.value} className="mb-3">
                        <div className="text-center p-3" style={{ border: '1px solid #e3e3e3', borderRadius: '8px' }}>
                          <h5 className="font-weight-bold mb-2">{slot.label}</h5>
                          <h2 className={`font-weight-bold mb-1 text-${tone}`}>
                            <CountUp end={slot.taken} duration={2} />
                            <span className="h6 text-dark">
                              {slot.capacity !== null ? ` / ${slot.capacity} 人` : ' 人'}
                            </span>
                          </h2>
                          {slot.capacity !== null && (
                            <>
                              <div className="progress" style={{ height: '8px' }}>
                                <div
                                  className={`progress-bar bg-${tone}`}
                                  role="progressbar"
                                  style={{ width: `${used}%` }}
                                  aria-valuenow={slot.taken}
                                  aria-valuemin="0"
                                  aria-valuemax={slot.capacity}
                                />
                              </div>
                              <small className="d-block mt-2">
                                {slot.full ? '已額滿' : `尚餘 ${slot.remaining} 位`}
                              </small>
                            </>
                          )}
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      )}

      {/* On the day itself, what matters is how many of each window have actually
          arrived rather than how many signed up. */}
      {timeslots && timeslots.length > 0 && (
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4" className="font-weight-bold mb-0">
                  各<span className="text-info">入場時段</span>Check-in 人數
                </Card.Title>
                <p className="card-category">實際到場人數 / 該時段報名人數</p>
              </Card.Header>
              <Card.Body>
                <Row>
                  {timeslots.map((slot) => {
                    const arrived = slot.checkedInPeople || 0;
                    const rate = slot.taken ? Math.min((arrived / slot.taken) * 100, 100) : 0;
                    return (
                      <Col md="4" key={slot.value} className="mb-3">
                        <div className="text-center p-3" style={{ border: '1px solid #e3e3e3', borderRadius: '8px' }}>
                          <h5 className="font-weight-bold mb-2">{slot.label}</h5>
                          <h2 className="font-weight-bold mb-1 text-info">
                            <CountUp end={arrived} duration={2} />
                            <span className="h6 text-dark">{` / ${slot.taken} 人`}</span>
                          </h2>
                          <div className="progress" style={{ height: '8px' }}>
                            <div
                              className="progress-bar bg-info"
                              role="progressbar"
                              style={{ width: `${rate}%` }}
                              aria-valuenow={arrived}
                              aria-valuemin="0"
                              aria-valuemax={slot.taken}
                            />
                          </div>
                          <small className="d-block mt-2">
                            {slot.taken
                              ? `到場率 ${Math.round(rate)}%（${slot.checkedInParties || 0} 組已報到）`
                              : '尚無報名'}
                          </small>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      )}

      <CSSTransition in={showCheckinTable} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <CheckinTable handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('checkin')} />
          </Col>
        </Row>
      </CSSTransition>

      <CSSTransition in={showTotalToday} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <TodayRegistration handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('totalToday')} />
          </Col>
        </Row>
      </CSSTransition>
    </>
  );
}

export default DataSnapshots;
